import { Box, Tab, Tabs } from '@mui/material';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import { EmployeesTable } from './employees/EmployeesTable';
import ClientsAndProjects from './clients-and-projects/ClientsAndProjects';
import { ManagerProxyTable } from './proxy/ManagerProxyTable';

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const ManagementTabs: React.FC = () => {
  const [value, setValue] = useState(0);
  const [selectedTabComponent, setSelectedTabComponent] = useState({});

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {}, [selectedTabComponent]);

  const setTabComponent = (index: number) => {
    if (index === 0) {
      return <EmployeesTable />;
    } else if (index === 1) {
      return <ClientsAndProjects />;
    } else if (index === 2) {
      return <ManagerProxyTable />;
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="management tabs">
          <Tab label="Employees" {...a11yProps(0)} />
          <Tab label="Clients and Projects" {...a11yProps(1)} />
          <Tab label="Manager Proxies" {...a11yProps(2)} />
        </Tabs>
      </Box>
      {setTabComponent(value)}
    </Box>
  );
};
